export const environment = {
  apiUrl: 'https://api.1cbn.ru/my',
  itsUrl: 'https://login.1c.ru',
  production: true,
};
